<!-- =========================================================================================
    Description: 3x3 grid selector for the 9 screen anchor positions
========================================================================================== -->

<template>
  <div class="anchor-position-picker">
    <label class="picker-label">Anchor Position</label>
    <div class="picker-grid">
      <div
        v-for="pos in positions"
        :key="pos.value"
        class="picker-cell"
        :class="{ 'picker-cell--active': value === pos.value }"
        :title="pos.label"
        @click="$emit('input', pos.value)"
      >
        <div class="picker-dot"></div>
      </div>
    </div>
    <div class="picker-current">{{ currentLabel }}</div>
  </div>
</template>

<script>
export default {
  name: 'AnchorPositionPicker',
  props: {
    value: {
      type: String,
      default: 'bottom-right',
    },
  },
  data() {
    return {
      positions: [
        { value: 'top-left',      label: 'Top Left' },
        { value: 'top-center',    label: 'Top Center' },
        { value: 'top-right',     label: 'Top Right' },
        { value: 'middle-left',   label: 'Middle Left' },
        { value: 'middle-center', label: 'Middle Center' },
        { value: 'middle-right',  label: 'Middle Right' },
        { value: 'bottom-left',   label: 'Bottom Left' },
        { value: 'bottom-center', label: 'Bottom Center' },
        { value: 'bottom-right',  label: 'Bottom Right' },
      ],
    }
  },
  computed: {
    currentLabel() {
      const pos = this.positions.find(p => p.value === this.value)
      return pos ? pos.label : this.value
    },
  },
}
</script>

<style lang="scss" scoped>
.anchor-position-picker {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

.picker-label {
  font-size: 0.8rem;
  color: #626262;
  margin-bottom: 6px;
}

.picker-grid {
  display: grid;
  grid-template-columns: repeat(3, 28px);
  grid-template-rows: repeat(3, 28px);
  gap: 4px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px;
}

.picker-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ddd;
  transition: background 0.15s, border-color 0.15s;

  &:hover {
    background: #e8f4fd;
    border-color: #7367f0;
  }

  &--active {
    background: #7367f0;
    border-color: #7367f0;

    .picker-dot {
      background: #fff;
    }
  }
}

.picker-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #bbb;
  transition: background 0.15s;
}

.picker-current {
  margin-top: 6px;
  font-size: 0.75rem;
  color: #7367f0;
  font-weight: 500;
}
</style>
